import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { showPopupParts } from '../../../../actions/price'
import DeviationList from './DeviationList'
import OtherDamageList from './OtherDamageList'
import EstimationList from './EstimationList'
import ExtentList from './ExtentList'
// import styles
import '../car.scss'
import './carpopup.scss'

// Elements
// import Icon from '../../../elements/icon'
import CloseButton from '../../../elements/closeButton'
import Inline from '../../../elements/inline'

// import { Icons } from '../../../elements/icons'

class CarPopup extends Component {
  constructor (props) {
    super(props)
    this.state = {
      showPopupForParts: this.props.showPopupForParts === true
    }
    this.renderPopupContent = this.renderPopupContent.bind(this)
    this.renderInsuranceContent = this.renderInsuranceContent.bind(this)
    this.renderComplaintOrDeviation = this.renderComplaintOrDeviation.bind(this)
    this.renderNormalContent = this.renderNormalContent.bind(this)
    this.close = this.close.bind(this)
  }
  componentDidMount () {
  }

  componentWillUnmount () {
  }
  reset (props) {
  }
  componentWillReceiveProps (nextProps) {
    if (nextProps.showPopupForParts !== this.state.showPopupForParts) {
      this.setState({
        showPopupForParts: nextProps.showPopupForParts
      })
    }
  }
  renderInsuranceContent () {
    // if (Number(window.carHandler.priceCalcType) !== 1) return null
    // if (window.carHandler.priceCalcType === 5 || window.carHandler.priceCalcType === 10) return null
    // Insurance or estimation list content
    return <EstimationList close={this.close} show={this.state.showPopupForParts} />
  }
  renderComplaintOrDeviation () {
    // if ((window.carHandler.priceCalcType !== 5 && window.carHandler.priceCalcType !== 10) return null
    // Complaints & Deviation
    return <DeviationList close={this.close} show={this.state.showPopupForParts} />
  }
  renderOtherDamage () {
    // if (window.carHandler.priceCalcType !== 30) return null
    // Other Damages
    return <OtherDamageList close={this.close} show={this.state.showPopupForParts} />
  }
  renderNormalContent () {
    // let notPermitted = [1, 5, 10]
    // if (notPermitted.includes(Number(window.carHandler.priceCalcType))) return null
    // Normal price list extent
    return <ExtentList close={this.close} isPaint={this.props.isPaint} show={this.state.showPopupForParts} />
  }
  renderPopupContent () {
    const isInsurance = window.carHandler.priceCalcType === 1 && (window.carHandler.priceCalcType !== 5 && window.carHandler.priceCalcType !== 10)
    const isComplaintOrDeviation = (window.carHandler.priceCalcType === 5 || window.carHandler.priceCalcType === 10)
    const isOtherDamage = window.carHandler.priceCalcType === 30
    const isNormalContent = ![1, 5, 10, 30].includes(window.carHandler.priceCalcType)

    return (
      <div className='carPopup--content carForm'>
        <div className='carSection fullWidth clearfixer'>
          {isInsurance && this.renderInsuranceContent()}
          {isComplaintOrDeviation && this.renderComplaintOrDeviation()}
          {isOtherDamage && this.renderOtherDamage()}
          {isNormalContent && this.renderNormalContent()}
        </div>
      </div>
    )
  }
  close () {
    this.props.showPopupParts(false)
    this.setState({
      showPopupForParts: false
    })
    this.reset(this.props)
  }
  render () {
    if (this.props.showPopupForParts !== true) return null
    // Render
    let title = 'Part'
    if (typeof window.carHandler.headers[this.props.selectedBodyPart] !== 'undefined') {
      title = window.carHandler.headers[this.props.selectedBodyPart]
    }
    let baseClassName = 'carPopup carPopup1'
    let notPermitted = [1, 5, 10]
    let showBig = notPermitted.indexOf(Number(window.carHandler.priceCalcType)) > -1
    if (this.props.isPaint && !showBig) {
      baseClassName += ' smaller'
    }
    if (this.props.isPaint && showBig) {
      baseClassName += ' estimate'
    }
    let backdropClassname = 'carPopupBackdrop'
    if (showBig && Number(window.carHandler.priceCalcType) !== 1) backdropClassname += ' estimate'
    return (
      <div className='carPopupWrapper1'>
        <div className='carPopupBackdrop1' onClick={this.close} />
        <div className={backdropClassname} onClick={this.close} />
        <div className={baseClassName}>
          <div className='carPopup--title'>
            <Inline block fillChildNum={[0]} spacing={0} alignChildren='center'>
              {title}
              <CloseButton onClick={this.close} />
            </Inline>
          </div>
          {this.renderPopupContent()}
        </div>
      </div>
    )
  }
}
CarPopup.defaultProps = {
  isPaint: false
}
CarPopup.propTypes = {
  isPaint: PropTypes.bool,
  show: PropTypes.bool.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    price: state.price.price,
    order: state.orders.order,
    showPopupForParts: state.price.showPopupForParts,
    selectedBodyPart: state.price.selectedBodyPart
  }
}

export default connect(mapStateToProps, {
  showPopupParts
})(CarPopup)



// WEBPACK FOOTER //
// ./src/app/shared/components/Car/CarPopup/index.js